module.exports = __webpack_public_path__ + "img/FemaleAvatar.ac7dcc06.png";